var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "validation", attrs: { tag: "form" } },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "form" },
          [
            _c("app-divider", {
              attrs: { label: "Upload de cadastros realizados em campo" }
            }),
            _c(
              "div",
              { staticClass: "radio-buttons" },
              [
                _c(
                  "el-radio-group",
                  {
                    staticClass: "radio-group",
                    attrs: { name: "radios", size: "small" },
                    on: { change: _vm.setGeomensorVistoriador },
                    model: {
                      value: _vm.isRetificacao,
                      callback: function($$v) {
                        _vm.isRetificacao = $$v
                      },
                      expression: "isRetificacao"
                    }
                  },
                  [
                    _c(
                      "el-radio",
                      {
                        staticClass: "radio",
                        attrs: { label: false, border: "border" }
                      },
                      [_vm._v("Cadastro")]
                    ),
                    _c(
                      "el-radio",
                      {
                        staticClass: "radio",
                        attrs: { label: true, border: "border" }
                      },
                      [_vm._v("Retificação")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "height-upload" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c("app-label", {
                            staticClass: "margin-top",
                            attrs: { label: "Upload do .SiCARF:" }
                          }),
                          _c("app-upload-area", {
                            staticClass: "margin-bottom",
                            attrs: {
                              id: "anexo",
                              target: _vm.urlUpload,
                              fileType: _vm.validExtensions,
                              onSuccess: _vm.onSuccess,
                              documento: _vm.documento,
                              maxSize: 10000000,
                              errors: errors
                            },
                            on: {
                              download: _vm.download,
                              removerDocumento: _vm.removerDocumento,
                              onError: _vm.onError
                            },
                            model: {
                              value: _vm.documento,
                              callback: function($$v) {
                                _vm.documento = $$v
                              },
                              expression: "documento"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm.isPa
              ? _c(
                  "div",
                  { staticClass: "margin-top" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c("validation-provider", {
                              attrs: { rules: _vm.isRequired() },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("app-label", {
                                          attrs: {
                                            label: "Ordem de Serviço: ",
                                            required: _vm.isRetificacao
                                              ? false
                                              : true
                                          }
                                        }),
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: {
                                              filterable: "filterable",
                                              placeholder:
                                                "Selecione a Ordem de Serviço:",
                                              disabled: _vm.isRetificacao
                                                ? true
                                                : false,
                                              required: _vm.isRetificacao
                                                ? false
                                                : true
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.changeOrdemServico(
                                                  _vm.ordemServico
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.ordemServico,
                                              callback: function($$v) {
                                                _vm.ordemServico = $$v
                                              },
                                              expression: "ordemServico"
                                            }
                                          },
                                          _vm._l(_vm.ordensServicos, function(
                                            os
                                          ) {
                                            return _c("el-option", {
                                              key: os.id,
                                              attrs: {
                                                label: os.numero,
                                                value: os.id
                                              }
                                            })
                                          }),
                                          1
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "help erro" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1511437906
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c("validation-provider", {
                              attrs: { rules: _vm.isRequired() },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("app-label", {
                                          attrs: {
                                            label: "Geomensor Responsável:",
                                            required: _vm.isRetificacao
                                              ? false
                                              : true
                                          }
                                        }),
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: {
                                              filterable: "filterable",
                                              required: _vm.isRetificacao
                                                ? false
                                                : true,
                                              disabled:
                                                _vm.isDisabledResponsavel,
                                              placeholder:
                                                "Selecione o geomensor responsável:"
                                            },
                                            model: {
                                              value: _vm.geomensorResponsavel,
                                              callback: function($$v) {
                                                _vm.geomensorResponsavel = $$v
                                              },
                                              expression: "geomensorResponsavel"
                                            }
                                          },
                                          _vm._l(_vm.usuarios, function(u) {
                                            return _c("el-option", {
                                              key: u.id,
                                              attrs: {
                                                label: u.nome,
                                                value: u.id
                                              }
                                            })
                                          }),
                                          1
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "help erro" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                4267627633
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c("validation-provider", {
                              attrs: { rules: _vm.isRequired() },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("app-label", {
                                          attrs: {
                                            label: "Vistoriador Responsável:",
                                            required: _vm.isRetificacao
                                              ? false
                                              : true
                                          }
                                        }),
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: {
                                              filterable: "filterable",
                                              required: _vm.isRetificacao
                                                ? false
                                                : true,
                                              placeholder:
                                                "Selecione o vistoriador responsável:",
                                              disabled:
                                                _vm.isDisabledResponsavel
                                            },
                                            model: {
                                              value: _vm.vistoriadorResponsavel,
                                              callback: function($$v) {
                                                _vm.vistoriadorResponsavel = $$v
                                              },
                                              expression:
                                                "vistoriadorResponsavel"
                                            }
                                          },
                                          _vm._l(_vm.usuarios, function(u) {
                                            return _c("el-option", {
                                              key: u.id,
                                              attrs: {
                                                label: u.nome,
                                                value: u.id
                                              }
                                            })
                                          }),
                                          1
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "help erro" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2042719680
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c("validation-provider", {
                              attrs: { rules: _vm.isRequired() },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("app-label", {
                                          attrs: {
                                            label: "Analista GCG/CGIR:",
                                            required: _vm.isRetificacao
                                              ? false
                                              : true
                                          }
                                        }),
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: {
                                              placeholder:
                                                "Selecione o analista responsável:",
                                              required: _vm.isRetificacao
                                                ? false
                                                : true,
                                              disabled:
                                                _vm.isDisabledResponsavel,
                                              clearable: "clearable"
                                            },
                                            model: {
                                              value: _vm.analistaGcgCgir,
                                              callback: function($$v) {
                                                _vm.analistaGcgCgir = $$v
                                              },
                                              expression: "analistaGcgCgir"
                                            }
                                          },
                                          _vm._l(_vm.analistasGcgCgir, function(
                                            u
                                          ) {
                                            return _c("el-option", {
                                              key: u.id,
                                              attrs: {
                                                label:
                                                  u.pessoa.pessoaFisica.nome,
                                                value: u.id
                                              }
                                            })
                                          }),
                                          1
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "help erro" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                188526518
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "el-button",
              { attrs: { type: "success" }, on: { click: _vm.enviar } },
              [
                _vm._v("Enviar cadastro "),
                _c("i", { staticClass: "el-icon-check" })
              ]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-507fb5fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-507fb5fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/receptor/Upload.vue
// module id = null
// module chunks = 